export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12788.6997a1a2.jpg";